import type { ProjectScope } from './project-scope';

const pendingSoundClipWriteKeys = new Set<string>();
const pendingSoundClipDeleteKeys = new Set<string>();
const pendingSoundCueWriteKeys = new Set<string>();
const pendingSoundCueDeleteKeys = new Set<string>();
const pendingMicAssignmentWriteKeys = new Set<string>();
const pendingMicAssignmentDeleteKeys = new Set<string>();
const pendingMicSwapWriteKeys = new Set<string>();
const pendingMicSwapDeleteKeys = new Set<string>();
const pendingMicPackConfigWriteKeys = new Set<string>();

function scopedEntityKey(scope: ProjectScope, id: string): string {
    return `${scope.orgId}/${scope.projectId}/${id}`;
}

function scopedConfigKey(scope: ProjectScope): string {
    return `${scope.orgId}/${scope.projectId}`;
}

function clearDeletesMissingFromRemote(
    keys: Set<string>,
    scope: ProjectScope,
    remoteIds: ReadonlySet<string>
): void {
    const scopedKeys = Array.from(keys)
        .filter(key => key.startsWith(`${scope.orgId}/${scope.projectId}/`));
    for (const key of scopedKeys) {
        const id = key.slice(`${scope.orgId}/${scope.projectId}/`.length);
        if (!remoteIds.has(id)) {
            keys.delete(key);
        }
    }
}

export function markPendingSoundClipWrite(scope: ProjectScope, id: string): void {
    pendingSoundClipWriteKeys.add(scopedEntityKey(scope, id));
}

export function clearPendingSoundClipWrite(scope: ProjectScope, id: string): void {
    pendingSoundClipWriteKeys.delete(scopedEntityKey(scope, id));
}

export function isPendingSoundClipWrite(scope: ProjectScope, id: string): boolean {
    return pendingSoundClipWriteKeys.has(scopedEntityKey(scope, id));
}

export function markPendingSoundClipDelete(scope: ProjectScope, id: string): void {
    pendingSoundClipDeleteKeys.add(scopedEntityKey(scope, id));
}

export function isPendingSoundClipDelete(scope: ProjectScope, id: string): boolean {
    return pendingSoundClipDeleteKeys.has(scopedEntityKey(scope, id));
}

export function clearPendingSoundClipDeletesMissingFromRemote(scope: ProjectScope, remoteIds: ReadonlySet<string>): void {
    clearDeletesMissingFromRemote(pendingSoundClipDeleteKeys, scope, remoteIds);
}

export function markPendingSoundCueWrite(scope: ProjectScope, id: string): void {
    pendingSoundCueWriteKeys.add(scopedEntityKey(scope, id));
}

export function clearPendingSoundCueWrite(scope: ProjectScope, id: string): void {
    pendingSoundCueWriteKeys.delete(scopedEntityKey(scope, id));
}

export function isPendingSoundCueWrite(scope: ProjectScope, id: string): boolean {
    return pendingSoundCueWriteKeys.has(scopedEntityKey(scope, id));
}

export function markPendingSoundCueDelete(scope: ProjectScope, id: string): void {
    pendingSoundCueDeleteKeys.add(scopedEntityKey(scope, id));
}

export function isPendingSoundCueDelete(scope: ProjectScope, id: string): boolean {
    return pendingSoundCueDeleteKeys.has(scopedEntityKey(scope, id));
}

export function clearPendingSoundCueDeletesMissingFromRemote(scope: ProjectScope, remoteIds: ReadonlySet<string>): void {
    clearDeletesMissingFromRemote(pendingSoundCueDeleteKeys, scope, remoteIds);
}

export function markPendingMicAssignmentWrite(scope: ProjectScope, id: string): void {
    pendingMicAssignmentWriteKeys.add(scopedEntityKey(scope, id));
}

export function clearPendingMicAssignmentWrite(scope: ProjectScope, id: string): void {
    pendingMicAssignmentWriteKeys.delete(scopedEntityKey(scope, id));
}

export function isPendingMicAssignmentWrite(scope: ProjectScope, id: string): boolean {
    return pendingMicAssignmentWriteKeys.has(scopedEntityKey(scope, id));
}

export function markPendingMicAssignmentDelete(scope: ProjectScope, id: string): void {
    pendingMicAssignmentDeleteKeys.add(scopedEntityKey(scope, id));
}

export function isPendingMicAssignmentDelete(scope: ProjectScope, id: string): boolean {
    return pendingMicAssignmentDeleteKeys.has(scopedEntityKey(scope, id));
}

export function clearPendingMicAssignmentDeletesMissingFromRemote(scope: ProjectScope, remoteIds: ReadonlySet<string>): void {
    clearDeletesMissingFromRemote(pendingMicAssignmentDeleteKeys, scope, remoteIds);
}

export function markPendingMicSwapWrite(scope: ProjectScope, id: string): void {
    pendingMicSwapWriteKeys.add(scopedEntityKey(scope, id));
}

export function clearPendingMicSwapWrite(scope: ProjectScope, id: string): void {
    pendingMicSwapWriteKeys.delete(scopedEntityKey(scope, id));
}

export function isPendingMicSwapWrite(scope: ProjectScope, id: string): boolean {
    return pendingMicSwapWriteKeys.has(scopedEntityKey(scope, id));
}

export function markPendingMicSwapDelete(scope: ProjectScope, id: string): void {
    pendingMicSwapDeleteKeys.add(scopedEntityKey(scope, id));
}

export function isPendingMicSwapDelete(scope: ProjectScope, id: string): boolean {
    return pendingMicSwapDeleteKeys.has(scopedEntityKey(scope, id));
}

export function clearPendingMicSwapDeletesMissingFromRemote(scope: ProjectScope, remoteIds: ReadonlySet<string>): void {
    clearDeletesMissingFromRemote(pendingMicSwapDeleteKeys, scope, remoteIds);
}

export function markPendingMicPackConfigWrite(scope: ProjectScope): void {
    pendingMicPackConfigWriteKeys.add(scopedConfigKey(scope));
}

export function clearPendingMicPackConfigWrite(scope: ProjectScope): void {
    pendingMicPackConfigWriteKeys.delete(scopedConfigKey(scope));
}

export function isPendingMicPackConfigWrite(scope: ProjectScope): boolean {
    return pendingMicPackConfigWriteKeys.has(scopedConfigKey(scope));
}

export function clearPendingSoundWrites(): void {
    pendingSoundClipWriteKeys.clear();
    pendingSoundClipDeleteKeys.clear();
    pendingSoundCueWriteKeys.clear();
    pendingSoundCueDeleteKeys.clear();
    pendingMicAssignmentWriteKeys.clear();
    pendingMicAssignmentDeleteKeys.clear();
    pendingMicSwapWriteKeys.clear();
    pendingMicSwapDeleteKeys.clear();
    pendingMicPackConfigWriteKeys.clear();
}
